require('./mortgageRequestCoHolderView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { isEmpty } = require('lodash');
const get = require('lodash/object/get');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const { MortgageRequestHolderInformation } = require('components/mortgageRequest/mortgageRequestHolderInformation/mortgageRequestHolderInformation');

// @ actions
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');

class MortgageRequestCoHolderSelectView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            holderType: 1
        };

        this.propietor = {};

        this.handleHolderTypeRadioChange = this.handleHolderTypeRadioChange.bind(this);
        this.filterPropietor = this.filterPropietor.bind(this);
    }

    componentWillMount() {
        const { dataPropietorState, requestDataProprietor } = this.props;
        if (!dataPropietorState.get('data', []).count()) {
            requestDataProprietor();
        } else {
            this.propietor = this.filterPropietor(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { match: { params: { holderNum } }, dataPropietorState } = nextProps;
        if (holderNum && dataPropietorState.get('data', []).count() && isEmpty(this.propietor)) {
            this.propietor = this.filterPropietor(nextProps);
        }
    }

    filterPropietor(props) {
        const { match: { params: { holderNum } }, dataPropietorState } = props;
        const dataPropietorInfoObject = dataPropietorState.get('data').toJS();
        const dataPropietorInfo = dataPropietorInfoObject.filter(
            x => x.numeroTitular === parseInt(holderNum, 10)
        );
        if (dataPropietorInfo.length) {
            return dataPropietorInfo[0];
        }
        return {};
    }

    handleHolderTypeRadioChange(value) {
        this.setState({
            holderType: parseInt(value),
        });
    }

    render() {
        const { tipoDocumentoIdentidad, identificador } = get(this.propietor, 'datosPersonales.documentoDeIdentidad', {});
        const holderId = `${tipoDocumentoIdentidad}-${identificador}`;
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage'
            },
            {
                text: formatText('mortgageRequestCoHolder-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        let coHolderInformation = <LoadingSection />;
        if (!isEmpty(this.propietor)) {
            coHolderInformation = (
                <MortgageRequestHolderInformation
                    isHolder={false}
                    holderId={holderId}
                    isClientWithoutAccounts={isClientWithoutAccounts}
                />
            );
        }

        return (
            <div className="mortgage-request-co-holder-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestCoHolder-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {coHolderInformation}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestCoHolderSelectView.propTypes = {
    match: PropTypes.object.isRequired,
    dataPropietorState: PropTypes.object,
    requestDataProprietor: PropTypes.func,
    immGlobalPosition: PropTypes.object.isRequired
};

module.exports.constructor = MortgageRequestCoHolderSelectView;

module.exports.MortgageRequestCoHolderSelectView = connect(
    state => ({
        dataPropietorState: state.mortgageRequestDataProprietor,
        immGlobalPosition: state.globalPosition,
    }), {
        requestDataProprietor: dataProprietorActions.requestDataProprietor
    })(MortgageRequestCoHolderSelectView);
